import { AxiosResponse } from 'axios';

import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const updateVesselTanks = ({ vesselId, vesselTanks }: any): Promise<AxiosResponse> => {
    return authorizedAxiosInstance.put(`/v2/vessel-tanks/${vesselId}`, {
        vesselTanks,
    });
};
